export const SIDEBAR_WIDTH = '16rem';
